import { render, staticRenderFns } from "./GSurveyChart.vue?vue&type=template&id=796b7fe0&scoped=true&"
import script from "./GSurveyChart.vue?vue&type=script&lang=ts&"
export * from "./GSurveyChart.vue?vue&type=script&lang=ts&"
import style0 from "./GSurveyChart.vue?vue&type=style&index=0&id=796b7fe0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796b7fe0",
  null
  
)

export default component.exports